import React, { useState, useEffect } from 'react';
import FourPillars from '../components/FourPillars';

const EnterprisePage = () => {
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        'why-choose',
        'solutions',
        'key-benefits'
      ];
      
      const scrollPosition = window.scrollY + 150;
      
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setActiveSection(sectionId);
    }
  };

  return (
    <main className="services">
      <div className="container">
        <div className="sv-content-wrapper">
          <div className="sv-main-content">
            {/* Hero */}
            <section className="sv-hero">
              <div className="sv-eyebrow">Enterprise</div>
              <h1 className="sv-title">Large-Scale Asset Management Solutions for Enterprise Organizations</h1>
              <p className="sv-subtitle">Comprehensive asset disposition and value recovery solutions designed for large-scale enterprise operations. Handle IT assets, excess inventory, returns, and facility closures with enterprise-grade processes and reporting.</p>
            </section>

            {/* Why Choose */}
            <section id="why-choose" className="sv-features">
              <h2 className="sv-section-title">Why Enterprise Organizations Choose Us</h2>
        <div className="sv-features-grid">
          <div className="sv-feature">
            <h4>Enterprise Scale</h4>
            <p>Handle large volumes across multiple locations with scalable processes and dedicated account management.</p>
          </div>
          <div className="sv-feature">
            <h4>Comprehensive Solutions</h4>
            <p>End-to-end services covering IT assets, inventory, returns, and facility closures with integrated reporting.</p>
          </div>
          <div className="sv-feature">
            <h4>Security & Compliance</h4>
            <p>Enterprise-grade security, compliance, and documentation meeting strict regulatory and audit requirements.</p>
          </div>
          <div className="sv-feature">
            <h4>Strategic Partnership</h4>
            <p>Dedicated account management and strategic partnership to align with your business objectives and goals.</p>
          </div>
        </div>
      </section>

            {/* Solutions */}
            <section id="solutions" className="sv-overview">
              <h2 className="sv-section-title">Enterprise Solutions</h2>
        <ul className="sv-bullets sv-list">
          <li>IT Asset Disposition – Secure data destruction and asset recovery for enterprise IT infrastructure</li>
          <li>Facility Closures – Complete liquidation of facilities, inventory, and equipment for multi-location operations</li>
          <li>Returns Management – Enterprise-scale returns processing with brand protection and value recovery</li>
          <li>Excess Inventory – Strategic liquidation of excess inventory across multiple product categories</li>
          <li>Supply Chain Optimization – Streamline supply chain by disposing of obsolete, damaged, or excess materials</li>
          <li>Compliance & Reporting – Comprehensive compliance support and audit-ready documentation</li>
        </ul>
      </section>

            {/* Benefits */}
            <section id="key-benefits" className="sv-overview">
              <h2 className="sv-section-title">Key Benefits</h2>
        <ul className="sv-bullets sv-list">
          <li>Scale operations across multiple locations and business units</li>
          <li>Maximize recovery value through strategic multi-channel routing</li>
          <li>Ensure compliance with enterprise security and regulatory requirements</li>
          <li>Gain comprehensive reporting and analytics for strategic decision-making</li>
          <li>Reduce operational overhead by outsourcing complex disposition tasks</li>
          <li>Access dedicated account management and strategic partnership</li>
        </ul>
      </section>

            {/* Four Pillars */}
            <FourPillars />

            {/* CTA */}
            <section className="sv-cta">
              <div className="sv-cta-inner">
                <h3>Ready to optimize your enterprise asset management?</h3>
                <p>Get a free assessment and discover how we can support your large-scale operations.</p>
                <div className="sv-cta-actions">
                  <a className="btn btn-primary" href="tel:+18778739336">Call (877) 873-9336</a>
                  <a className="btn btn-secondary" href="mailto:info@globoflo.com">Email Us</a>
                </div>
              </div>
            </section>
          </div>

          {/* Quick Links Sidebar */}
          <aside className="sv-quick-links">
            <h3 className="sv-quick-links-title">Enterprise</h3>
            <nav className="sv-quick-links-nav">
              <ul>
                <li>
                  <button 
                    className={activeSection === 'why-choose' ? 'active' : ''}
                    onClick={() => scrollToSection('why-choose')}
                  >
                    Why Enterprise Organizations Choose Us
                  </button>
                </li>
                <li>
                  <button 
                    className={activeSection === 'solutions' ? 'active' : ''}
                    onClick={() => scrollToSection('solutions')}
                  >
                    Enterprise Solutions
                  </button>
                </li>
                <li>
                  <button 
                    className={activeSection === 'key-benefits' ? 'active' : ''}
                    onClick={() => scrollToSection('key-benefits')}
                  >
                    Key Benefits
                  </button>
                </li>
              </ul>
            </nav>
          </aside>
        </div>
      </div>
    </main>
  );
};

export default EnterprisePage;

